// extracted by mini-css-extract-plugin
export default {"wrapper":"JT-z","availablePromoMessagesLabel":"KT-z","promoMessageList":"LT-z","promoMessage":"MT-z","appliedPromoMessage":"NT-z","promoMessageAmount":"OT-z"};